angular.module('eStories.registration', [

    /*Registration Module*/
    'global.validation.model',
    'eStories.account.model',
    'eStories.registration.model'


])
    .controller('RegistrationCtrl', [
        'ModalsModel',
        'ValidationModel',
        '$uibModalInstance',
        'RegistrationModel',
        'AccountModel',
        '$rootScope',
        '$scope',
        'GoogleModel',
        'LL',
        'GA',
        'PromoModel',
        '$location',
        'GiftModel',
        '$aria',
        'AffiliatesProgramModel',
        function (ModalsModel, ValidationModel, $uibModalInstance, RegistrationModel, AccountModel, $rootScope, $scope,
                  GoogleModel, LL, GA, PromoModel, $location, GiftModel, $aria, AffiliatesProgramModel) {

            var regCtrl = this;

            $scope.$on('modal.closing', function () {
                regCtrl.serverError = null;
            });

            regCtrl.handleSignUpError = function (response) {
                var errorMessage;
                switch (response.responseText) {
                    case 'INTERNAL_ERROR' :
                        errorMessage = 'We are unable to complete your signup due to an internal error.' +
                            ' We apologize for the inconvenience, please try again.';
                        break;
                    case 'INVALID_EMAIL':
                        errorMessage = 'Please enter a valid email address.';
                        break;
                    case 'INVALID_PASSWORD' :
                        errorMessage = 'Minimum 6 characters is required!';
                        break;
                    case 'INVALID_FULL_NAME':
                        errorMessage = '‘Please enter a valid name';
                        break;
                    case 'INVALID_COUNTRY_CODE':
                        errorMessage = 'Invalid country code, please try again.';
                        break;
                    case 'USER_ALREADY_EXISTS':
                        errorMessage = 'This email is in use on an existing account. Please sign in or use a different email';
                        break;
                }
                regCtrl.serverError = errorMessage;
            };

            regCtrl.handleSignInResponse = function (response) {
                if (response != null && response.responseStatus == 'SUCCESS') {
                    if (response.signUp) {
                        GoogleModel.trackConversion("NCxVCMfQ3mgQ_puwuQM", 0.01, "USD");
                    }
                    AccountModel.refreshUserDetails(function () {
//                        eligibility logic vvvvv
//                            user is offered promo and doesnt have active subscription - offer them promo in updatePaymentModal
                        if (PromoModel.hasPlanPromo()) {
                            AccountModel.pendingPlanPurchaseType = 'PROMO';
                        }
                        if (GiftModel.giftToken != null) {
                            AccountModel.acceptGift();
                        }
                        $rootScope.$broadcast('successfulSignIn');
                        $uibModalInstance.close();

                    });
                } else {
                    var errorMessage;
                    switch (response.responseText) {
                        case 'INTERNAL_ERROR':
                            errorMessage = 'Unable to login due to an internal error. We apologize for the inconvenience, please try again.';
                            break;
                        case 'INVALID_EMAIL':
                            //given when the user's email isn't formatted right.
                            errorMessage = 'Incorrect Email. The email you entered doesn\'t appear to be formatted correctly.  Please try again.';
                            break;
                        case 'USER_NOT_FOUND':
                            errorMessage = 'Password does not match username. Please try again.';
                            break;
                        case 'INCORRECT_PASSWORD':
                            errorMessage = 'Incorrect Password. The password you entered does not match our records.' +
                                ' Please try again or reset password.';
                            break;
                        case 'DEVICE_LIMIT_EXCEEDED':
                            errorMessage = 'You have exceeded the limit on the number of devices that can access this account.';
                            break;
                        default:
                            errorMessage = 'Internal Error (' + response.responseText + ')';
                            break;
                    }
                    regCtrl.serverError = errorMessage;
                }
            };

            /*CLOSE REGISTRATION MODAL*/
            regCtrl.closeRegModal = function (modalId) {
                angular.element('body').css('padding', '0');
                $uibModalInstance.close(modalId);
            };

            regCtrl.getHeaderText = function () {
                if (GiftModel.giftToken) {
                    return "SIGN UP";
                }
                if (AccountModel.pendingPlanPurchaseType == "BASIC_TRIAL") {
                    return "START FREE TRIAL";
                } else {
                    return "SIGN UP";
                }
            };

            regCtrl.showRegSignUpModal = function () {
                AccountModel.showSignUp();
            };

            /*OPEN REGISTRATION MODAL*/
            regCtrl.openRegModal = function (modalId) {
                ModalsModel.open(modalId, 'RegistrationCtrl', 'regCtrl');
            };

            regCtrl.showForgotPwModal = function () {
                LL.tagEvent('Selected Forgot Password');
                regCtrl.openRegModal('/registration/forgotPassword/forgotPw.tmpl.html');
            };

            /*SHOW PASSWORD and passwordConfirm ON INPUT*/
            regCtrl.showPassword = function (show) {
                if (show) {
                    angular.element('.password').attr("type", "text");
                    angular.element('.passwordConfirm').attr("type", "text");
                    regCtrl.showPw = true;
                } else {
                    angular.element('.password').attr("type", "password");
                    angular.element('.passwordConfirm').attr("type", "password");
                    regCtrl.showPw = false;
                }
            };


            regCtrl.passwordShowButtonText = function () {
                if (angular.element('.password').attr("type") === "password") {
                    return regCtrl.passwordShowButtonText = "SHOW";
                } else {
                    return regCtrl.passwordShowButtonText = "HIDE";
                }
            };

            regCtrl.getRandomString = function () {
                if (regCtrl.randomStr) {
                    return regCtrl.randomStr;
                }
                regCtrl.randomStr = "em-" + Math.random().toString(36).substring(2, 13);
                return regCtrl.randomStr;
            };

            /*LOCAL VALIDATIONS*/

            regCtrl.formErrors = {};


            if (!eStoriesProduction()) {
                regCtrl.fullName = regCtrl.getRandomString();
                regCtrl.email = regCtrl.getRandomString() + "@mailinator.com";
                regCtrl.password = regCtrl.confirmPassword = regCtrl.getRandomString();
            }

            regCtrl.freeOfErrors = function () {
                var obj = regCtrl.formErrors;
                return Object.keys(obj).length === 0 && JSON.stringify(obj) === JSON.stringify({});
            };

            regCtrl.validateFullName = function (fullName) {
                return ValidationModel.validateFullName(fullName, regCtrl.formErrors);
            };

            regCtrl.validateEmail = function (email) {
                return ValidationModel.validateEmail(email, regCtrl.formErrors);
            };

            regCtrl.validatePassword = function (password) {
                return ValidationModel.validatePassword(password, regCtrl.formErrors);
            };

            regCtrl.validateConfirmPassword = function (password, confirmPassword) {
                return ValidationModel.validateConfirmPassword(password, confirmPassword, regCtrl.formErrors);
            };

            regCtrl.getFieldClass = function (fieldName, fieldValue, isTypingInProgress) {
                return ValidationModel.getFieldClass(fieldName, fieldValue, regCtrl.formErrors, isTypingInProgress);
            };

            /*FACEBOOK SIGN IN*/
            regCtrl.submitFacebookSignIn = async function () {
                const response = await RegistrationModel.submitFacebookSignIn();
                regCtrl.handleSignInResponse(response);
            };

            /*GOOGLE SIGN IN*/
            regCtrl.submitGoogleSignIn = async function () {
                const response = await RegistrationModel.submitGoogleSignIn();
                regCtrl.handleSignInResponse(response);
            };

            /*APPLE SIGN IN*/
            regCtrl.submitAppleSignIn = async function () {
                const response = await RegistrationModel.submitAppleSignIn(regCtrl.rememberMe);
                regCtrl.handleSignInResponse(response);
            };

            /*EMAIL SIGN IN*/
            regCtrl.submitSignIn = async function () {

                if (!regCtrl.freeOfErrors()) {
                    return;
                }

                regCtrl.serverError = null;
                AffiliatesProgramModel.getUtmRequestObj();
                var signInObj = {
                    email: regCtrl.email,
                    password: regCtrl.password,
                    device: RegistrationModel.getDeviceObj(),
                    utmSource: AffiliatesProgramModel.getUtmRequestObj() ? AffiliatesProgramModel.getUtmRequestObj().utmSource : null,
                    utmCampaign: AffiliatesProgramModel.getUtmRequestObj() ? AffiliatesProgramModel.getUtmRequestObj().utmCampaign : null,
                    utmAffiliateTransId: AffiliatesProgramModel.getUtmRequestObj() ? AffiliatesProgramModel.getUtmRequestObj().utmAffiliateTransId : null,
                    utmMedium: AffiliatesProgramModel.getUtmRequestObj() ? AffiliatesProgramModel.getUtmRequestObj().utmMedium : null,
                };

                const response = await RegistrationModel.submitSignIn(signInObj);
                regCtrl.handleSignInResponse(response);
            };

            /*EMAIL SIGN UP*/
            regCtrl.submitSignUp = async function () {
                if (!regCtrl.freeOfErrors()) {
                    return;
                }

                regCtrl.serverError = null;

                var signUpObj = {
                    fullName: regCtrl.fullName,
                    email: regCtrl.email,
                    password: regCtrl.password,
                    utmSource: AffiliatesProgramModel.getUtmRequestObj() ? AffiliatesProgramModel.getUtmRequestObj().utmSource : null,
                    utmCampaign: AffiliatesProgramModel.getUtmRequestObj() ? AffiliatesProgramModel.getUtmRequestObj().utmCampaign : null,
                    utmAffiliateTransId: AffiliatesProgramModel.getUtmRequestObj() ? AffiliatesProgramModel.getUtmRequestObj().utmAffiliateTransId : null,
                    utmMedium: AffiliatesProgramModel.getUtmRequestObj() ? AffiliatesProgramModel.getUtmRequestObj().utmMedium : null,
                };

                if (AffiliatesProgramModel.getAllUTMParams()) {
                    var utmRequestObj = AffiliatesProgramModel.getUtmRequestObj();
                }

                const response = await RegistrationModel.submitSignUp(signUpObj, utmRequestObj);
                if (response.responseStatus === 'SUCCESS') {
                    regCtrl.closeRegModal('/registration/signUpModal.tmpl.html');
                    regCtrl.submitSignIn();
                    GoogleModel.trackConversion("NCxVCMfQ3mgQ_puwuQM", 0.01, "USD");
                } else {
                    regCtrl.handleSignUpError(response);
                }
            };

            regCtrl.sendResetPassword = async function () {
                if (!regCtrl.freeOfErrors()) {
                    return;
                }
                const response = await RegistrationModel.sendResetPassword(regCtrl.sendResetPwEmail);
                if (response.responseStatus === 'SUCCESS') {
                    regCtrl.closeRegModal('/registration/forgotPassword/forgotPw.tmpl.html');
                }
            };
            regCtrl.resetPassword = async function () {
                if (!regCtrl.freeOfErrors()) {
                    return;
                }
                const response = await RegistrationModel.resetPassword($rootScope.resetPwToken, regCtrl.newPassword);
                if (response.responseStatus === 'SUCCESS') {
                    regCtrl.closeRegModal('/registration/resetPassword/resetPw.tmpl.html');
                    regCtrl.openRegModal('/registration/signInModal.tmpl.html');
                }
            }
        }]);
